'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const body1ClassNames = {
  root: 'fui-Body1'
};
/**
 * Styles for the root slot
 */
export const useBody1Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "figsok6",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});